(() => {
  const normalize = value => value.toUpperCase().replace(/[^A-Z0-9]/g, '');
  let indexPromise;
  class PPGPartSearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('input[name="q"]');
      this.panel = this.querySelector('.ppg-search__results');
      this.status = this.querySelector('[role="status"]');
      this.list = this.querySelector('ul');
      this.all = this.querySelector('.ppg-search__all');
      this.revision = 0;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.revision += 1;
        this.timer = setTimeout(() => this.search(), 220);
      });
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.hide();
      });
      this.querySelector('form').addEventListener('submit', event => {
        if (this.isReference(this.input.value)) {
          event.preventDefault();
          clearTimeout(this.timer);
          this.search();
        }
      });
      this.outside = event => { if (!this.contains(event.target)) this.hide(); };
      document.addEventListener('pointerdown', this.outside);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('pointerdown', this.outside);
    }
    isReference(value) {
      return normalize(value).length >= 6 && (value.match(/\d/g) || []).length >= 3;
    }
    hide() {
      this.revision += 1;
      this.panel.hidden = true;
    }
    async search() {
      const input = this.input.value.trim();
      const query = normalize(input);
      if (!this.isReference(input)) { this.hide(); return; }
      const revision = ++this.revision;
      this.panel.hidden = false;
      this.list.replaceChildren();
      this.status.textContent = this.dataset.loading;
      this.all.href = `${this.dataset.root}search?type=product&q=${encodeURIComponent(input)}`;
      try {
        indexPromise ||= fetch(this.dataset.index).then(response => {
          if (!response.ok) throw new Error('Index unavailable');
          return response.json();
        }).catch(error => { indexPromise = undefined; throw error; });
        const index = await indexPromise;
        const candidates = index.products.map(item => ({item, exact: item.references.includes(query)}))
          .filter(({item, exact}) => exact || normalize(item.title).includes(query))
          .sort((a, b) => Number(b.exact) - Number(a.exact)).slice(0, 12);
        const live = await Promise.all(candidates.map(async candidate => {
          try {
            const response = await fetch(`${this.dataset.root}products/${encodeURIComponent(candidate.item.handle)}.js`);
            if (!response.ok) return null;
            return {...candidate, product: await response.json()};
          } catch { return null; }
        }));
        if (revision !== this.revision) return;
        const results = live.filter(Boolean);
        this.status.textContent = results.length ? `${results.length} ${candidates.some(c => c.exact) ? this.dataset.exact : this.dataset.related}` : this.dataset.empty;
        const fragment = document.createDocumentFragment();
        for (const {item, exact, product} of results) {
          const row = document.createElement('li');
          const link = document.createElement('a');
          link.className = 'ppg-search__result';
          link.href = `${this.dataset.root}products/${encodeURIComponent(item.handle)}`;
          const image = document.createElement('img');
          image.alt = '';
          image.width = image.height = 60;
          image.loading = 'lazy';
          if (product.featured_image) {
            const url = new URL(product.featured_image, location.origin);
            url.searchParams.set('width', '120');
            image.src = url.href;
          }
          const text = document.createElement('div');
          const title = document.createElement('strong');
          title.textContent = product.title;
          const match = document.createElement('span');
          match.className = 'ppg-match';
          match.textContent = exact ? this.dataset.exact : this.dataset.related;
          const price = document.createElement('span');
          price.textContent = `${product.price_varies ? this.querySelector('[data-ppg-from]').textContent + ' ' : ''}${new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:this.dataset.currency || 'GBP'}).format(product.price / 100)} · ${product.available ? this.dataset.available : this.dataset.soldOut}`;
          text.append(title, match, price);
          link.append(image, text);
          row.append(link);
          fragment.append(row);
        }
        this.list.replaceChildren(fragment);
      } catch {
        if (revision !== this.revision) return;
        this.panel.hidden = true;
        this.querySelector('form').submit();
      }
    }
  }
  if (!customElements.get('ppg-part-search')) customElements.define('ppg-part-search', PPGPartSearch);
})();
